import { NgModule , provideAppInitializer, inject} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';;
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxsModule } from '@ngxs/store';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { environment } from 'src/environments/environment.prod';
import { UserDataState } from './shared/utilities/states/userData.state';
import { GlobalStoreOperation } from './shared/utilities/store-operations';
import { DexieOperations } from './shared/utilities/dexie-operation';
import { httpInterceptProviders } from './shared/services/auth-interceptors/auth-interceptor-provider.service';
import { ColumnDefinitionState } from './shared/utilities/states/columnDefenition.state';
import { WbidHelper } from './shared/utilities/helper';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { LZservice } from './shared/services/lz.services';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CurrentBidDataState } from './shared/utilities/states/currentBidData.state';
import { INIState } from './shared/utilities/states/ini.state';
import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { LinesState } from './shared/utilities/states/line.state';
import { StateFileState } from './shared/utilities/states/stateFile.state';
import { NumberOnlyDirective } from './shared/directives/number-only.directive';
import { TripState } from './shared/utilities/states/trip.state';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { ToasterService } from './shared/services/Toaster.services';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { QuickSetState } from './shared/utilities/states/quickSet.state';
import {
  LoginRouteGuard,
  RegistrationGuard,
  MainGuard,
  BidlineGuard,
} from './shared/utilities/RouteGuard';
// import { BnNgIdleService } from 'bn-ng-idle';
import { NgxMaskModule } from 'ngx-mask';
import { ConfigurationsComponent } from '../app/shared/common-components/configurations/configurations.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { AppInitService } from './shared/services/app-init.service';

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        MatCardModule,
        MatTableModule,
        MatInputModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSnackBarModule,
        MDBBootstrapModule.forRoot(),
        NgxExtendedPdfViewerModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonToggleModule,
        NgxsModule.forRoot([
            UserDataState,
            ColumnDefinitionState,
            CurrentBidDataState,
            INIState,
            LinesState,
            StateFileState,
            TripState,
            QuickSetState,
        ], {
            developmentMode: environment.production,
        }),
        NgxsStoragePluginModule.forRoot({
            key: [
                UserDataState,
                ColumnDefinitionState,
                CurrentBidDataState,
                INIState,
                LinesState,
                StateFileState,
                TripState,
                QuickSetState,
            ],
        }),
        NgxsLoggerPluginModule.forRoot({
            collapsed: false,
            disabled: environment.production,
        }),
        NgxLoadingModule.forRoot({
            animationType: ngxLoadingAnimationTypes.chasingDots,
        }),
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }),
        NgxsReduxDevtoolsPluginModule.forRoot(),
        NgxMaskModule.forRoot()], providers: [
        httpInterceptProviders,
        GlobalStoreOperation,
        DexieOperations,
        WbidHelper,
        LZservice,
        ToasterService,
        LoginRouteGuard,
        RegistrationGuard,
        MainGuard,
        BidlineGuard,
         provideAppInitializer(() => {
            const appInitService = inject(AppInitService); // inject manually
            return appInitService.initApp();
        }),
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
